let menusDashboards = []
let menusDocument = []

menusDashboards = [
    {
        icon: 'zmdi zmdi-view-dashboard',
        class: 'hasSpaceTop d-none',
        title: 'ข้อมูลสรุป ด่านตรวจคนเข้าเมือง',
        code: 'dashboard',
        path: '/admin/dashboard/immigration-checkpoint',
        children: null,
        permission_group: ['perm_01', 'perm_03', 'perm_04'],
        widgets: [
            {
                code: 133,
                show: false,
            },
            {
                code: 134,
                show: false,
            },
            {
                code: 135,
                show: false,
            },
            {
                code: 136,
                show: false,
            },
            {
                code: 137,
                show: false,
            },
            {
                code: 138,
                show: false,
            },
            {
                code: 139,
                show: false,
            },
            {
                code: 140,
                show: false,
            },
        ],
    },
]

menusDocument = []
export const menusDashboard = menusDashboards
export const menusDocuments = menusDocument

export const menusWidgets = {
    icon: 'ti-list',
    class: 'hasSpaceTop',
    title: 'หมวดหมู่ Widget',
    code: 'Widgets',
    path: '/admin/widget',
    children: [
        {
            title: 'รายได้จากการท่องเที่ยวในแต่ละพื้นที่',
            path: '/admin/widget/revenue-tourism/23',
        },
    ],
}

export const menusSmartDatas = {
    icon: 'zmdi zmdi-calendar-check mr-2',
    class: 'hasSpaceTop',
    title: 'หน้าหลัก Smart Data',
    code: 'smartdata_menu',
    path: 'https://smartdata.tourismthailand.org',
    permission_group: ['perm_01', 'perm_02', 'perm_03', 'perm_04'],
}

export const menusMonitorTravel = {
    icon: 'zmdi zmdi-calendar-check mr-2',
    class: 'hasSpaceTop',
    title: 'ติดตามเฝ้าระวังการเดินทางเข้าประเทศ',
    code: 'monitor_travel_menu',
    path: '/admin/dashboard/monitor-travel',
    permission_group: ['perm_01', 'perm_03', 'perm_04'],
}

export const menusImmigrations = {
    icon: 'zmdi zmdi-calendar-check mr-2',
    class: 'hasSpaceTop menu-dashboard d-none',
    title: 'ตารางข้อมูล ด่านตรวจคนเข้าเมือง',
    code: 'dashboard',
    path: '/admin/widget/immigrations/140',
    permission_group: ['perm_01', 'perm_03', 'perm_04'],
}

export const menusCaats = {
    icon: 'zmdi zmdi-calendar-check mr-2',
    class: 'hasSpaceTop d-none',
    title: 'การบินพลเรือนแห่งประเทศไทย',
    code: 'dashboard',
    path: '/admin/widget', //path: '/admin/widget/caats/141',
    children: [
        {
            title: 'สถิติข้อมูลการขนส่งทางอากาศ',
            path: '/admin/widget/caats/141.3',
        },
        {
            title: 'เที่ยวบินระหว่างประเทศ',
            path: '/admin/widget/caats/141.1',
        },
        {
            title: 'เที่ยวบินภายในประเทศ',
            path: '/admin/widget/caats/141.2',
        },
    ],
    permission_group: ['perm_01', 'perm_02', 'perm_03', 'perm_04'],
}

export const menusCdds = {
    icon: 'zmdi zmdi-calendar-check mr-2',
    class: 'hasSpaceTop',
    title: 'ข้อมูลสรุป กรมการพัฒนาชุมชน',
    code: 'dashboard',
    path: '/admin/widget/cdds',
    children: [
        {
            title: 'ข้อมูลสรุป กรมการพัฒนาชุมชน',
            path: '/admin/widget/cdds/144.1',
        },
        {
            title: 'ข้อมูลสรุป กรมการพัฒนาชุมชนแยกตามจังหวัด',
            path: '/admin/widget/cdds/144.2',
        },
    ],
    permission_group: ['perm_01', 'perm_02', 'perm_03', 'perm_04'],
}

export const menusIncomes = {
    icon: 'zmdi zmdi-calendar-check mr-2',
    class: 'hasSpaceTop',
    title: 'รายได้ค่าใช้จ่ายตลาดในประเทศ',
    code: 'incomes',
    path: '/admin/widget',
    children: [
        {
            title: 'รายได้จากการท่องเที่ยวในแต่ละพื้นที่',
            path: '/admin/widget/revenue-tourism/23',
        },
        {
            title: 'รายได้การท่องเที่ยวจำแนกตามภูมิภาค',
            path: '/admin/widget/revenue-tourism/24',
        },
    ],
    permission_group: ['perm_01', 'perm_02', 'perm_03', 'perm_04'],
}

export const menusEstimateCostOfForeignMarket = {
    icon: 'zmdi zmdi-calendar-check mr-2',
    class: 'hasSpaceTop',
    title: 'ค่าใช้จ่ายตลาดต่างประเทศ',
    code: 'estimate_cost_of_foreign_market',
    path: '/admin/widget',
    children: [
        {
            title: 'ค่าใช้จ่ายเฉลี่ยของนักท่องเที่ยวระหว่างประเทศ',
            path: '/admin/widget/revenue-tourism/27',
        },
    ],
    permission_group: ['perm_01', 'perm_02', 'perm_03', 'perm_04'],
}

export const menusVos = {
    icon: 'zmdi zmdi-calendar-check mr-2',
    class: 'hasSpaceTop',
    title: 'สรุป Social Listening',
    code: 'social_listening',
    path: '/admin/widget',
    children: [
        {
            title: 'รายงานข้อมูลที่มีการกล่าวถึงจังหวัด และแหล่งท่องเที่ยวในระบบ Social Listening (ข้อมูลตั้งแต่ 1 ธันวาคม 2563)',
            path: '/admin/widget/voice-of-stakeholder/123.1',
        },
        {
            title: 'สัดส่วน sentiment ของคำสนทนา',
            path: '/admin/widget/voice-of-stakeholder/123',
        },
        {
            title: 'ความมุ่งหมาย (Purpose) ของคำสนทนา',
            path: '/admin/widget/voice-of-stakeholder/124',
        },
        {
            title: 'สัดส่วน Sentiment ของแคมเปญ',
            path: '/admin/widget/voice-of-stakeholder/9',
        },
        {
            title: 'Content ที่ได้รับ Engagement สูงสุด',
            path: '/admin/widget/voice-of-stakeholder/57',
        },
        {
            title: 'ปริมาณการโพส ของประเทศคู่แข่ง',
            path: '/admin/widget/voice-of-stakeholder/58',
        },
    ],
    permission_group: ['perm_01', 'perm_02', 'perm_03', 'perm_04'],
}

export const menusInformationStatistic = {
    icon: 'zmdi zmdi-calendar-check mr-2',
    class: 'hasSpaceTop',
    title: 'สภาพอากาศกรมอุตุนิยมวิทยา',
    code: 'information_statistic',
    path: '/admin/widget',
    children: [
        {
            title: 'อุณหภูมิแต่ละช่วงเวลา',
            path: '/admin/widget/information/95',
        },
        {
            title: 'ข้อมูล อุณหภูมิและปริมาณน้ำฝน',
            path: '/admin/widget/information/96',
        },
    ],
    permission_group: ['perm_01', 'perm_02', 'perm_03', 'perm_04'],
}

export const menusWorldOutbound = [
    {
        icon: 'zmdi zmdi-calendar-check mr-2',
        class: 'hasSpaceTop menu-dashboard',
        title: 'จำนวนนักท่องเที่ยวเดินทางออกนอกประเทศ',
        code: 'dashboard',
        path: '/admin/widget/market/131',
        permission_group: ['perm_01', 'perm_02', 'perm_03', 'perm_04'],
    },
    {
        icon: 'zmdi zmdi-calendar-check mr-2',
        class: 'hasSpaceTop menu-dashboard',
        title: 'ข้อมูลจาก World Bank',
        code: 'dashboard',
        path: '/admin/widget/market/127',
        permission_group: ['perm_01', 'perm_02', 'perm_03', 'perm_04'],
    },
]

export const menusAccessReport = {
    icon: 'zmdi zmdi-calendar-check mr-2',
    class: 'hasSpaceTop',
    title: 'สถิติการเข้าใช้งาน',
    code: 'access-report',
    path: '/admin/widget',
    children: [
        {
            title: 'รายงานสถิติการเข้าใช้งานระบบ Business Intelligent',
            path: '/admin/widget/access-report/151',
        },
        {
            title: 'รายงานสถิติการเข้าใช้งานระบบ E-Survey และ E-Form',
            path: '/admin/widget/access-report/150',
        },
        {
            title: 'จำนวนรายการข้อมูลในระบบฐานข้อมูล ( TATIC - Smart )',
            path: '/admin/widget/access-report/152',
        },
        {
            title: 'รายงานจำนวนการสร้างและตอบแบบสอบถามใบระบบ E-Survey และ E-Form',
            path: '/admin/widget/access-report/153',
        },
    ],
    permission_group: ['perm_03'],
}

export const menusSettings = {
    icon: 'ti-settings',
    class: '',
    title: 'message.settings',
    code: 'setting',
    path: '/admin/setting',
    children: [
        { title: 'message.widgets_category', path: '/admin/setting/category' },
        { title: 'message.widgets_list', path: '/admin/setting/widgets' },
        { title: 'message.usersGroup', path: '/admin/setting/users/group' },
        // { title: 'message.usersAdDepartment', path: '/admin/setting/users/department_ad' },
        { title: 'message.usersList', path: '/admin/setting/users' },
    ],
}
